module.exports = __webpack_public_path__ + "img/squares_grey.84622ced.svg";